import { OneMinuteInMillis } from '@racemap/utilities/consts/time';
import type { RacemapFeatureCollection } from '@racemap/utilities/types/geos';
import type { ObjectId } from '@racemap/utilities/types/utils';
import { useMemo } from 'react';
import useSWR, { type SWRConfiguration } from 'swr';
import { apiClient } from '.';

/**
 * Returns the geo elements of an event
 *
 * @returns {event: RacemapFeatureCollection | undefined, isLoading: boolean, error: Error}
 */

export function useEventGeoElements(
  { eventId }: { eventId?: string | ObjectId | null },
  options?: SWRConfiguration,
): {
  geoElements: RacemapFeatureCollection | null | undefined;
  isLoading: boolean;
  error: Error;
} {
  const { data, isLoading, error } = useSWR(
    eventId != null ? ['GET', 'EVENT_GEOS', eventId.toString()] : null,
    async ([, , eventId]) => {
      if (eventId == null) return null;
      const geos = await apiClient.getEventGeo(eventId.toString());

      return geos;
    },
    {
      revalidateIfStale: false,
      refreshInterval: OneMinuteInMillis * 5,
      keepPreviousData: true,
      ...options,
    },
  );

  const out = useMemo(() => ({ geoElements: data, isLoading, error }), [data, isLoading, error]);
  return out;
}
